import {routeTo} from '@/utils/router'

export const useTramaInMediaContent = () => ({
  title: 'about-us.trama-in-media-title',
  articles: [
    {
      logo: '/images/media/the-sunday-times.png',
      altLogo: 'The Sunday Times logo',
      linkText: 'about-us.trama-in-media-sunday-times-article',
      linkHref: routeTo.blog.industryArticle(
        'general',
        'trama-features-in-sunday-times-business-owners-checklist',
      ),
      openInNewTab: false,
    },
    {
      logo: '/images/media/valiant-ceo.png',
      altLogo: 'Valiant CEO logo',
      linkText: 'about-us.trama-in-media-valiant-ceo-article',
      linkHref:
        'https://valiantceo.com/every-brand-deserves-to-be-protected-and-trama-makes-that-possible/',
      openInNewTab: true,
    },
    {
      logo: '/images/media/legaltech-breakthrough-awards.png',
      altLogo: 'Legaltech breakthrough awards logo',
      linkText: 'about-us.trama-in-media-legaltech-breakthrough-article',
      linkHref: 'https://legaltechbreakthrough.com/2021-winners/',
      openInNewTab: true,
    },
    {
      logo: '/images/media/the-european-business-review.png',
      altLogo: 'The European Business Review logo',
      linkText: 'about-us.trama-in-media-eu-business-review-article',
      linkHref:
        'https://www.europeanbusinessreview.com/thriving-companies-protect-their-1-asset-trademark-registration-just-got-easier-with-euipo-grant-up-to-1500e/',
      openInNewTab: true,
    },
  ],
})
